<template>
  <v-layout class="column">
    <v-tabs
      class="notifications-tab-wrapper"
      v-model="active"
      color="white"
      grow
      slider-color="primary"
    >
      <v-tab
        v-for="notify in notification_label"
        :key="notify"
        ripple
      >{{ getStateWithParam(notify) }}</v-tab>
      <v-tab-item v-for="n in 3" :key="n">
        <v-card flat>
          <v-card-text>
            <BaseAlertCard />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
export default {
  name: "MyRaports",
  props: {},
  components: {},
  data() {
    return {
      notification_label: [
        "favorite_notifications",
        "not_favorite_notifications"
      ],
      active: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  methods: {
    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    }
  }
};
</script>


<style scope lang="scss" src="./Notification.scss">
</style>


